var map = {
	"./add.svg": 352,
	"./add_queue.svg": 353,
	"./album.svg": 354,
	"./archive.svg": 355,
	"./audio_file.svg": 356,
	"./bell.svg": 357,
	"./blue_dot_icon.svg": 358,
	"./caret_down.svg": 359,
	"./caret_up.svg": 360,
	"./cart.svg": 361,
	"./check.svg": 362,
	"./circle-minus.svg": 363,
	"./close.svg": 364,
	"./cloud-upload.svg": 365,
	"./collection.svg": 366,
	"./copy.svg": 367,
	"./delete.svg": 368,
	"./download.svg": 369,
	"./edit.svg": 370,
	"./editor_admin.svg": 371,
	"./expand_collapse.svg": 372,
	"./favorite.svg": 373,
	"./folder-open.svg": 374,
	"./genre.svg": 375,
	"./info_panel.svg": 376,
	"./info_round.svg": 377,
	"./init_editor.svg": 378,
	"./instrument.svg": 379,
	"./link.svg": 380,
	"./list-plus.svg": 381,
	"./log-out.svg": 382,
	"./menu.svg": 383,
	"./natural_language.svg": 384,
	"./now_playing.svg": 385,
	"./open_editor.svg": 386,
	"./pause.svg": 387,
	"./playlist_reorder.svg": 388,
	"./playlists.svg": 389,
	"./queue.svg": 390,
	"./quick_filter.svg": 391,
	"./radio.svg": 392,
	"./receipt.svg": 393,
	"./remove.svg": 394,
	"./rotate-cw.svg": 395,
	"./save-all.svg": 396,
	"./save.svg": 397,
	"./scroll-text.svg": 398,
	"./search.svg": 399,
	"./settings.svg": 400,
	"./share_add_person.svg": 401,
	"./share_copy_link.svg": 402,
	"./similar_tracks.svg": 403,
	"./sort.svg": 404,
	"./split.svg": 405,
	"./tag.svg": 406,
	"./text_search.svg": 407,
	"./track.svg": 408,
	"./triangle-alert.svg": 409,
	"./triangle.svg": 410,
	"./upload.svg": 411,
	"./user-minus.svg": 412,
	"./user-shield.svg": 413,
	"./variation.svg": 414,
	"./volume.svg": 415,
	"./volume_muted.svg": 416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 818;